var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsites(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 72,
    viewBox: "0 0 113 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.37 0.0635986H0.0478516V72H112.37V0.0635986Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.159 9.08643H3.26001V67.7444H109.159V9.08643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.322 0H0V4.77188H112.322V0Z",
    fill: "#4F65FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.061 15.5052H61.5144V52.7122H100.061V15.5052Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54591 3.324C4.03436 3.324 4.43032 2.92803 4.43032 2.43959C4.43032 1.95114 4.03436 1.55518 3.54591 1.55518C3.05746 1.55518 2.6615 1.95114 2.6615 2.43959C2.6615 2.92803 3.05746 3.324 3.54591 3.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90297 3.324C7.39141 3.324 7.78738 2.92803 7.78738 2.43959C7.78738 1.95114 7.39141 1.55518 6.90297 1.55518C6.41452 1.55518 6.01855 1.95114 6.01855 2.43959C6.01855 2.92803 6.41452 3.324 6.90297 3.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2601 3.324C10.7486 3.324 11.1446 2.92803 11.1446 2.43959C11.1446 1.95114 10.7486 1.55518 10.2601 1.55518C9.7717 1.55518 9.37573 1.95114 9.37573 2.43959C9.37573 2.92803 9.7717 3.324 10.2601 3.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6827 15.4288H11.4036V25.7079H21.6827V15.4288Z",
    fill: "#4F65FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9772 15.4877H25.6981V25.7668H35.9772V15.4877Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.018 29.6074H25.7389V63.8105H36.018V29.6074Z",
    fill: "#4F65FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.402 29.5312H11.1229V47.0308H21.402V29.5312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5272 21.3823C78.8344 18.5228 75.4868 18.3896 75.4868 18.3896C75.4868 18.3896 72.2243 17.9724 70.1314 22.3273C68.1807 26.3865 65.4884 30.3054 69.6984 31.2559L70.4588 28.8893L70.9297 31.432C71.5291 31.4751 72.1304 31.4854 72.7308 31.4628C77.239 31.3173 81.5322 31.5055 81.394 29.8882C81.2098 27.7373 82.1555 24.1335 80.5272 21.3823Z",
    fill: "#31475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9745 48.5349L63.2673 52.4977C63.2673 52.4977 59.938 55.9855 62.3161 55.9855C64.6941 55.9855 65.6453 52.9734 65.6453 52.9734L72.9379 49.8027L68.9745 48.5349Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2732 33.0779C71.2732 33.0779 66.2794 48.5354 67.8647 49.3277C69.4499 50.12 72.9377 50.5959 72.9377 50.5959L71.2732 33.0779Z",
    fill: "#31475E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.2732 33.0779C71.2732 33.0779 66.2794 48.5354 67.8647 49.3277C69.4499 50.12 72.9377 50.5959 72.9377 50.5959L71.2732 33.0779Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9727 52.578H75.731L83.718 48.5354C83.8941 48.6496 84.063 48.7745 84.2237 48.9095C85.408 49.9065 86.3484 51.1613 86.9727 52.578Z",
    fill: "#31475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4438 29.1144C76.7203 29.1144 78.5657 27.269 78.5657 24.9926C78.5657 22.7161 76.7203 20.8707 74.4438 20.8707C72.1674 20.8707 70.322 22.7161 70.322 24.9926C70.322 27.269 72.1674 29.1144 74.4438 29.1144Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3646 28.401C74.3646 28.401 75.3158 31.4131 74.3646 32.523C73.4134 33.6328 79.5963 30.9376 79.5963 30.9376C79.5963 30.9376 77.3769 27.767 78.0109 26.3401L74.3646 28.401Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4957 42.1635L83.1628 44.3338C83.1628 44.3338 83.3309 44.8268 83.5353 45.5451C83.8017 46.482 84.1299 47.802 84.2233 48.9091C84.32 50.0316 84.1741 50.9352 83.4798 50.9922C82.4843 51.0746 81.9658 51.6786 81.4489 52.5776H69.9805C70.0106 52.083 70.047 51.5693 70.0899 51.0414C70.1137 50.7243 70.1399 50.403 70.1686 50.0775C70.2004 49.7034 71.3233 42.6756 70.4794 41.1632C68.736 38.0402 70.955 36.2487 70.955 36.2487C70.955 36.2487 71.272 33.8706 71.272 33.078C71.272 32.4566 73.7071 31.7384 74.7598 31.4562C74.8281 31.4387 74.8883 31.4213 74.9435 31.4087C75.1258 31.3612 75.2352 31.3342 75.2352 31.3342L76.0676 30.993C76.0676 30.993 78.4059 30.5412 78.5645 30.224C78.6659 30.0874 78.808 29.9863 78.9704 29.9354C79.3048 29.7927 79.7314 29.6912 79.8329 29.5897C79.9777 29.4231 80.1087 29.245 80.2244 29.057C80.5284 28.7083 80.9382 28.4686 81.3912 28.3747C83.0939 27.945 85.5401 28.7964 85.5401 28.7964L84.684 34.3847L83.4957 42.1635Z",
    fill: "#31475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4744 38.7058L82.7672 42.6686C82.7672 42.6686 79.4379 46.1564 81.816 46.1564C84.194 46.1564 85.1445 43.1448 85.1445 43.1448L92.4371 39.9742L88.4744 38.7058Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6694 21.1066L75.3616 19.3745L73.287 19.696C72.5518 19.8101 71.8679 20.1427 71.3241 20.6504C70.7803 21.1582 70.4017 21.8178 70.2375 22.5434L69.8491 24.2569L72.2017 24.1663L72.859 22.6328V24.141L73.9446 24.0993L74.5744 21.6578L74.9681 24.2568L78.8271 24.178L78.6694 21.1066Z",
    fill: "#31475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4314 29.1145L85.5412 28.7975C85.5412 28.7975 96.7971 33.395 96.4801 37.3583C96.1631 41.3216 96.6386 41.3211 94.7362 41.4801C92.8338 41.6392 87.2856 39.7362 87.443 39.4192C87.6005 39.1022 88.7113 37.5165 88.7113 37.5165L84.4308 34.1873L84.4314 29.1145Z",
    fill: "#31475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5656 25.6268C78.9158 25.6268 79.1998 25.3428 79.1998 24.9926C79.1998 24.6423 78.9158 24.3584 78.5656 24.3584C78.2153 24.3584 77.9314 24.6423 77.9314 24.9926C77.9314 25.3428 78.2153 25.6268 78.5656 25.6268Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.061 58.6924H61.5144V63.8319H100.061V58.6924Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.402 50.8926H11.1229V63.7343H21.402V50.8926Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6335 15.5579H40.3544V47.0306H50.6335V15.5579Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5927 50.924H40.3136V63.773H50.5927V50.924Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.37,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsites);
export default __webpack_public_path__ + "static/media/websites.8608d7ea.svg";
export { ForwardRef as ReactComponent };